angular.module('dealerware.web.data').factory('DealerwareScanCollection', function (Collection, $mobilityCompanyAuthentication) {
  'use strict';

  function createHeader(data, duplicateEvents, eventType, offLotEvent, values = []) {
    duplicateEvents.forEach(event => {
      if (offLotEvent) {
        duplicateHeader(data, event, eventType, offLotEvent)
      }
      if (values.includes(event.data.event_received_at)) {
        duplicateHeader(data, event, eventType, offLotEvent)
      }
    });
  }

  function duplicateHeader(data, event, eventType, offLotEvent) {
    let newRow = angular.copy(event);
    newRow.data.event_type = eventType;
    newRow.data.id = null;
    newRow.offLotEvent = offLotEvent || null;
    newRow.headerRow = true;
    return data.splice(data.indexOf(event), 0, newRow);
  }

  function createSubRows(collection, scan, targetAttribute) {
    collection.forEach(collectionTarget => {
      if (targetAttribute && (targetAttribute === collectionTarget)) {
        if (!scan.headerRow) {
          scan.hidden = true;
          scan.subRow = true;
        }
      }
    });
  }

  const prepareCarScans = (_, data) => {
    if ($mobilityCompanyAuthentication.location.settings.geolite) {
      // determine the first (latest) scan that correlates to each off lot event
      const offLotEventIds = data.map(scan => scan.data.off_lot_event_id);
      const rowsToBeDuplicated = data.filter((scan, scanIndex) =>
        scan.data.off_lot_event_id && (scanIndex === offLotEventIds.indexOf(scan.data.off_lot_event_id))
      );

      createHeader(data, rowsToBeDuplicated, "Off Lot", true)
      data.forEach(scan => createSubRows(offLotEventIds, scan, scan.data.off_lot_event_id))
    }

    const eventTimes = data.map(scan => scan.data.event_received_at);
    // calculateNumberOfEvents returns an object with the count of events that occur.
    /*
        {
          2021-03-03T12:43:10Z: 5
          2021-03-03T12:44:10Z: 5
          2021-03-03T12:45:10Z: 2
          2021-03-03T12:46:10Z: 2
          2021-03-03T12:47:10Z: 1
          2021-03-03T12:48:10Z: 1
        }
    */
    const calculateNumberOfEvents = data
      .map(scan => scan.data.event_received_at)
      .reduce((acc, cur) => {
        if (acc[cur]) {
          acc[cur] = acc[cur] + 1;
        } else {
          acc[cur] = 1;
        }

        return acc
      }, {});

    // collectDuplicateEventTimes returns an array of timestamps which are duplicate events from the calculateNumberOfEvents.
    // ['2021-03-03T12:43:10Z', '2021-03-03T12:44:10Z', '2021-03-03T12:45:10Z', '2021-03-03T12:46:10Z']
    const collectDuplicateEventTimes = Object
      .entries(calculateNumberOfEvents)
      .filter(value => value[1] > 1)
      .map(item => item[0]);

    const eventsToBeDuplicated = data
      .filter((scan, scanIndex) =>
        scan.data.event_type === 'periodic_polling' && (scanIndex === eventTimes.indexOf(scan.data.event_received_at))
      );

    createHeader(data, eventsToBeDuplicated, "Periodic Polling Grouping", null, collectDuplicateEventTimes);

    data.forEach(scan => {
      if (scan.data.event_type !== 'periodic_polling') return scan;
      if (!collectDuplicateEventTimes.includes(scan.data.event_received_at) && !scan.data.off_lot_event_id) return scan;
      createSubRows(eventTimes, scan, scan.data.event_received_at)
    });
  }

  const collection = new Collection({
    baseEndpoint: '/locations/:location_id/cars/:vehicle_id/car_scans',
    model: 'DealerwareScanModel',
    customActions: {
      getScans: {
        endpoint: '/locations/:location_id/cars/:vehicle_id/car_scans',
        method: 'GET',
        ignoreDefaultRootNodeResponse: true,
        ignoreDefaultAssociationMapper: true
      },
    },
    responseTransforms: {
      getScans: prepareCarScans,
    }
  });

  return collection;
});
